import React, { FunctionComponent } from "react";
import { srOnly } from "@components/a11yStyles";

let politeRef: HTMLDivElement | null = null;
let assertiveRef: HTMLDivElement | null = null;

export const announcePolite = (message: string) => {
  if (politeRef) {
    politeRef.textContent = "";
    requestAnimationFrame(() => {
      if (politeRef) politeRef.textContent = message;
    });
  }
};

export const announceAssertive = (message: string) => {
  if (assertiveRef) {
    assertiveRef.textContent = "";
    requestAnimationFrame(() => {
      if (assertiveRef) assertiveRef.textContent = message;
    });
  }
};

export const LiveRegion: FunctionComponent = () => {
  return (
    <>
      <div
        ref={(el) => { politeRef = el; }}
        aria-live="polite"
        aria-atomic="true"
        role="log"
        className={srOnly}
      />
      <div
        ref={(el) => { assertiveRef = el; }}
        aria-live="assertive"
        aria-atomic="true"
        role="alert"
        className={srOnly}
      />
    </>
  );
};
